import Rete from 'rete';

import { distSocket, selectGrowthRate } from './index';

import samplingNumber from '../../util/density/samplingNumber';
import timeSlices from '../../util/density/timeSlices';

import NumControl from './NumControl';
import SelectControl from './SelectControl';
import ConditionalNumControl from './ConditionalNumControl';
import ButtonControl from './ButtonControl';
import DistPreviewControl from './DistPreviewControl';


import Vue from 'vue';
import { v4 as uuidv4 } from 'uuid';


export default class SquareDistComponent extends Rete.Component {

	constructor() {
		super("Square Distribution");
		this.path = ["Distribution"];
		this.contextMenuName = "Square";
	}

	builder(node) {
		let out = new Rete.Output('dist', "Output", distSocket);

		
		return node
			.addControl(new NumControl(this.editor, 'lower'))
			.addControl(new NumControl(this.editor, 'upper'))
			.addControl(new SelectControl(this.editor, 'timetype', false, selectGrowthRate))
			.addControl(new ConditionalNumControl(this.editor, 'growthrate'))
			.addControl(new ButtonControl(this.editor, 'parameters', false, node.id, ['lower', 'upper']))
			.addControl(new DistPreviewControl(this.editor, 'preview', true, node.id))
			.addOutput(out);
	}

	destroyed(node){

		// console.log(`Node ${node.id} was destroyed.`)

		// Remove all event listeners -- otherwise they will respond even if node does no longer exist

	}

	async worker(node, inputs, outputs) {

		// Get all predecessors
		let predecessors = [];

		// Iterate over sockets, and inputs to collect all predecessors (their UUIDs)
		for (let [socket, inputArray] of Object.entries(inputs)) {
			for (let i = 0; i < inputArray.length; i++){
				if (inputArray[i]){
					predecessors.push(inputArray[i]['predecessor']);
				} else {
					console.log('A predecessor could not be determined. Likely because an embedded module is currently open. Any tree view will then be incomplete.')
				}
			}
		}		
		
		// find control element
		let nodeSearch = this.editor.nodes.find(n => n.id == node.id);
		let growthRate = node.data.growthrate?node.data.growthrate:0;
		let growthSelector = node.data.timetype?node.data.timetype:'constant';
		let controlsElement = nodeSearch?nodeSearch.controls:undefined;
		
		if(nodeSearch) {
		
			// change visibility of growthrate input
			if( growthSelector == 'growthrate') {
				controlsElement.get('growthrate').setVisibility(true);
				controlsElement.get('parameters').setVisibility(false);
			} else if( growthSelector == 'individual') {
				controlsElement.get('parameters').setVisibility(true);
				controlsElement.get('growthrate').setVisibility(false);
			} else {
				controlsElement.get('growthrate').setVisibility(false);
				controlsElement.get('parameters').setVisibility(false);
			}
		}
		
		// link input values directly to parameter data object used with more periods
		node.data.parameters = node.data.parameters?node.data.parameters:[{}];
		node.data.parameters[0].lower = node.data.lower;
		node.data.parameters[0].upper = node.data.upper;		
		
		// ensure compatability and convert old values to new ones
		for (let k=2; k<=12; k++){
			if(node.data.parameters[k-1] == undefined && (node.data['lower'+k] || node.data['upper'+k])){
				node.data.parameters[k-1]={};
				if(node.data['lower'+k]){
					node.data.parameters[k-1].lower = node.data['lower'+k];
					delete node.data['lower'+k];
				}
				if(node.data['upper'+k]){
					node.data.parameters[k-1].upper = node.data['upper'+k];
					delete node.data['upper'+k];
				}
			}
		}
		
		// create random values and fill array / matrix
		let matrix = [];
		let timeSliceValue = timeSlices();
		let samplingValue = samplingNumber();
		
		for (let i = 0; i < timeSliceValue; i++) {
			let array = [];
			let GrowthFactor = Math.pow(1+growthRate,i);
			let lowerBound;
			let upperBound;
			if(growthSelector == 'individual'){
				lowerBound = node.data.parameters[i]?node.data.parameters[i].lower:undefined;
				upperBound = node.data.parameters[i]?node.data.parameters[i].upper:undefined;
			} else {
				lowerBound = node.data.parameters[0].lower;
				upperBound = node.data.parameters[0].upper;
			}
			//bug fix to corect string mistake in popup
			if(typeof lowerBound == "string") lowerBound = parseFloat(lowerBound);
			if(typeof upperBound == "string") upperBound = parseFloat(upperBound);
			
			for (let j = 0; j < samplingValue; j++) {
				let calculatedValue = Math.random() * Math.abs(upperBound - lowerBound) + Math.min(upperBound, lowerBound);
				if(growthSelector=='growthrate'){
					calculatedValue = calculatedValue * GrowthFactor;
				}
				array.push(calculatedValue);
			}
			matrix.push(array);
		}
		// update preview if node on screen (in editor)
		if (controlsElement) {
			controlsElement.get('preview').setValue(matrix);
		}

		// NEW
		// Generate a new UUID for this node instance(!)
		const nodeUUID = uuidv4();

		outputs['dist'] = {
			predecessor: nodeUUID,
			data: matrix,
		};

		let hasPredecessors = predecessors.length > 0 ? true : false;

		// Write global node data object
		Vue.prototype.$globalSharedData.globalNodeData[nodeUUID] = {
			hasPredecessors: hasPredecessors,
			predecessors: predecessors,
			nodeID: node.id,
			data: matrix,
			name: node.data.title,
			nodeFunction: node.name,
			module: undefined,
			nodeData: node.data,
		}
		
	}
}
